import { render, staticRenderFns } from "./olympus1000.vue?vue&type=template&id=1bc50a9b&scoped=true"
import script from "./olympus1000.vue?vue&type=script&lang=js"
export * from "./olympus1000.vue?vue&type=script&lang=js"
import style0 from "./olympus1000.vue?vue&type=style&index=0&id=1bc50a9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc50a9b",
  null
  
)

export default component.exports